import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import SafetyNote from "@/components/SafetyNote";
import RichText from "@/components/RichText";
import { Reveal, PrimaryButton } from "@/components/primitives";
import Snippet from "@/components/Snippet";
import { useSite } from "@/context/SiteContext";
import { ASSETS } from "@/data/content";

export default function Volunteer() {
  const { page, img } = useSite();
  const p = page("volunteer");
  const flyer = img("volunteer_flyer", ASSETS.flyer);

  return (
    <div>
      <PageHero {...p.hero} />

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <RichText html={p.body_html} />
            <div className="mt-8">
              <PrimaryButton as={Link} to="/book" data-testid="volunteer-book-btn">
                <Snippet k="volunteer.cta" fallback="Request a volunteer session" /> <ArrowRight size={18} strokeWidth={1.5} />
              </PrimaryButton>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="overflow-hidden lg:sticky lg:top-28 max-w-[80%] mx-auto">
              <img src={flyer} alt="QHHT volunteer sessions in South Devon" className="w-full h-auto object-contain" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal><SafetyNote /></Reveal>
        </div>
      </section>
    </div>
  );
}
